class AuthController {
    constructor() {
        this.name = 'auth';
    }
}

export default AuthController;



// WEBPACK FOOTER //
// ./client/app/routes/auth/auth.controller.js